import React, { useEffect, useState } from 'react';
import { Grid2, Card, CardContent, Typography, CardMedia, Button, Box } from '@mui/material';
import userPlaceholder from '../assets/userPlaceholder.png';
import Loadingrevolver from '../assets/loading.gif';


const CharacterImage = ({ src, alt }) => {
  const [imageError, setImageError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  return (
    <Box position="relative">
      {isLoading && (
        <Box position="absolute" width="100%" height="250px" display="flex" justifyContent="center" alignItems="center">
          <img src={Loadingrevolver} alt="loading..." style={{ width: '20%', height: 'auto' }} />
        </Box>
      )}
      <CardMedia
        component="img"
        height="250"
        image={imageError ? userPlaceholder : src}
        alt={alt}
        onLoad={() => setIsLoading(false)}
        onError={() => {
          setImageError(true);
          setIsLoading(false);
        }}
        sx={{
          display: isLoading ? 'none' : 'block'
        }}
      />
    </Box>
  );
};


function CharacterGrid() {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const discordID = localStorage.getItem('discordID');

    useEffect(() => {
        const fetchData = async () => {
            try {
              if (!discordID) {
                  console.log("Error, no discord ID provided")
                  return;
              }
              setIsLoading(true);
              console.log(`Fetching data for discordID: ${discordID}`)
              const response = await fetch(`${import.meta.env.VITE_REACT_API_URL}/api/char/${discordID}`);
              if (!response.ok) {
                throw new Error("Failed to fetch data");
              }
              const result = await response.json();
              
              const flattenedData = result.flat();
              
              setData(flattenedData);

            } catch (err) {
              setError(err.message);
              console.error("Error fetching data:", err);
            } finally {
              setIsLoading(false);
            }
          };
            fetchData();
    }, [discordID]);
    
    if (isLoading) {
        return <img src={Loadingrevolver} alt="loading..."  style={{ width: '10%', height: '10%' }}  />
    }

    if (error) {
        return <Typography>Error: {error}</Typography>
    }

    const handleSelectCharacter = async (charId, charName) => {
      try {
          const response = await fetch(`${import.meta.env.VITE_REACT_API_URL}/auth/selectchar`, {
              method: 'POST',
              credentials: 'include',
              headers: {
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify({ charId })
          });

          if (response.ok) {
              // Store selected character in localStorage
              localStorage.setItem('selectedChar', charId);
              localStorage.setItem('selectedCharName', charName);
              // Force a reload to update the sidebar
              window.location.reload();
          }
      } catch (error) {
          console.error('Error selecting character:', error);
      }
    };

    return (
        <Grid2 container spacing={4} padding={2} justifyContent="center" alignItems="center" sx={{ marginTop: 4 }}>
          {data.map((card) => (
            <Grid2 xs={12} sm={6} md={4} lg={3} key={card.id}>
              <Card>
                <CharacterImage 
                  src={card.pfp || userPlaceholder}
                  alt={`${card.firstname} ${card.lastname}`}
                />
                <CardContent>
                  <Typography variant="h5" component="div">{card.firstname} {card.lastname}</Typography>
                  <br />
                  <Typography variant="body2" color="text.secondary"><b>Database Identifier:</b> {card.charidentifier} </Typography>
                  <Typography variant="body2" color="text.secondary"><b>Last Login:</b> {card.LastLogin}</Typography>
                  <Typography variant="body2" color="text.secondary"><b>Money on Hand:</b> {card.money} </Typography>
                  <Typography variant="body2" color="text.secondary"><b>Job:</b> {card.job} </Typography>
                  <Typography variant="body2" color="text.secondary"><b>Time Played:</b> {card.hours} hrs</Typography>
                  <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    mt: 2
                  }}>
                    <Button variant="contained" color="primary" onClick={() => handleSelectCharacter(card.charidentifier, `${card.firstname} ${card.lastname}`)}>
                      Select Character
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid2>
          ))}
        </Grid2>
    )
}

export default CharacterGrid;